const history = {
  title: '我的專案',
  upgradeBtn: '升級',
  subTitle: '別忘了下載你的檔案，它將在72小時後刪除。',
  MAgo: '{{num}}分鐘以前',
  HAgo: '{{num}}小時以前',
  DAgo: '{{num}}天以前',
  justNow: '剛剛',
  originalFile: '原始檔案',
  selectAllBtn: '全選',
  emptyTips: '還沒有專案，<1>去編輯</1>',
  deleteTips: '您確定要刪除嗎？',
};

export default history;
